import { render, staticRenderFns } from "./AdHocGRN.vue?vue&type=template&id=638881ac&scoped=true&"
import script from "./AdHocGRN.vue?vue&type=script&lang=js&"
export * from "./AdHocGRN.vue?vue&type=script&lang=js&"
import style0 from "./AdHocGRN.vue?vue&type=style&index=0&id=638881ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638881ac",
  null
  
)

export default component.exports